import {PerfilModel} from "@/models/seguridad/perfil";
import PerfilAPI from "@/services/seguridad/perfil";
import * as R from "ramda";
import {scrollToForm} from '@/helpers/form-scroll-to';

function evaluateModelChangedFlag(data){
  if(!data && typeof data === "boolean")return data
  if(data && typeof data === "object")return data.length>=1;
}
const modelIsModified = R.curry((mod)=>R.compose(evaluateModelChangedFlag,mod.changed)());

//Base State
function BaseStateForm(){}
// States' consctructors
export function InitialState(self){
  //Assing context
  this.data = self;
  //Reset Models and validators
  this.resetModel();
  this.resetValidators();
  //View configuration
  this.data.view.elem.button.clear.visible=true;
  this.data.view.elem.button.audit.visible=false;
  this.data.view.elem.input.id.visible=false;
  this.data.view.elem.input.id.disabled=true;
  this.data.view.elem.button.submit.class.current = this.data.view.elem.button.submit.class.save;
  this.data.view.elem.button.submit.data.title.current = this.data.view.elem.button.submit.data.title.save;
}

export function EditingState(self, perfil){
  const {id, ["group_name"]:groupName , descripcion } = perfil;
  this.data = self;
  this.data.perfil = new PerfilModel({id, groupName , descripcion});
  this.data.view.elem.button.clear.visible=true;
  this.data.view.elem.button.audit.visible=true;
  this.data.view.elem.input.id.visible=true;
  this.data.view.elem.input.id.disabled=true;
  this.data.view.elem.button.submit.class.current = this.data.view.elem.button.submit.class.update;
  this.data.view.elem.button.submit.data.title.current = this.data.view.elem.button.submit.data.title.update;
  this.resetValidators();
}
// Setting Base as prototype
InitialState.prototype = Object.create(BaseStateForm.prototype);
EditingState.prototype = Object.create(BaseStateForm.prototype);
// Setting his own constructor instead of constructor's prototype
InitialState.prototype.constructor = InitialState;
EditingState.prototype.constructor = EditingState;
//Base skeleton
BaseStateForm.prototype.save   = function(){console.log("save no implementado"); return Promise.resolve()}
BaseStateForm.prototype.edit   = function(){console.log("edit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.submit = function(){console.log("submit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.askForClear = async function(){
  try{
    const response = await this.data.$swal({
      title: this.data.$t('view.global.swal.clear.title')
      , text: this.data.$t('view.global.swal.clear.text')
      , type: this.data.$t('view.global.swal.clear.type')
      , showCancelButton: this.data.$t('view.global.swal.clear.showCancelButton')
      , confirmButtonColor: this.data.$t('view.global.swal.clear.confirmButtonColor')
      , cancelButtonColor: this.data.$t('view.global.swal.clear.cancelButtonColor')
      , confirmButtonText: this.data.$t('view.global.swal.clear.confirmButtonText')
      , cancelButtonText: this.data.$t('view.global.swal.clear.cancelButtonText')
      , reverseButtons: true
    });
    if(response.value){
      this.data.state.clear();
    }
    return;
  }catch(error){
    console.log(error)
  }
}
BaseStateForm.prototype.clear = function(){Object.setPrototypeOf(this.data.state, new InitialState(this.data));}
BaseStateForm.prototype.audit = async function({clave, tabla, descripcion, revision}){
  try{
    auditoriaStates.EditingState({clave, tabla, descripcion, revision});
  }catch(error){
    console.log(error)
  }
}
BaseStateForm.prototype.resetModel = function(){this.data.perfil = new PerfilModel();}
BaseStateForm.prototype.resetValidators = function(){this.data.$v.$reset();}
BaseStateForm.prototype.isDisableButtonSubmit = function(){return this.data.hasErrors(this.data.$v.perfil)|| this.data.view.action.submit.busy}

//Initial State Implementation
InitialState.prototype.submit = async function({
  groupName
  , descripcion
  , estatus
}){
  try{
    if(!this.data.isAllValid(this.data.$v)){
      scrollToForm(this.data);
      return false;
    }
    this.data.view.action.submit.busy=true;
    const response = await PerfilAPI.save({groupName, descripcion});
    this.data.view.action.submit.busy=false;
    this.data.$refs.perfilTable.refreshData();
    Object.setPrototypeOf(this.data.state, new InitialState(this.data));
    return response;
  }catch(error){
    console.log(error)
    return error;
  }
}
//Editing State Implementation
EditingState.prototype.submit = async function(perfil){
  const {id, groupName , descripcion}=perfil;
  try{
    if(!this.data.isAllValid(this.data.$v)) {
      scrollToForm(this.data);
      return false;
    }
    this.data.view.action.submit.busy=true;
    const response = await PerfilAPI.update({id, groupName , descripcion});
    console.log(response)
    this.data.view.action.submit.busy=false;  
    this.data.$refs.perfilTable.refreshData();
    Object.setPrototypeOf(this.data.state, new InitialState(this.data));
    return response;
  }catch(error){
    console.log(error);
    return error;
  }
}
EditingState.prototype.isDisableButtonSubmit = function(){
  return this.data.hasErrors(this.data.$v.perfil) 
    || this.data.view.action.submit.busy
    || !modelIsModified(this.data.perfil)
}

//Saved State Implementation




// WEBPACK FOOTER //
// ./src/views/seguridad/perfil/perfil-states.js